var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('beat-loader',{style:({ height: _vm.height }),attrs:{"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }